/* global Swiper */
Wee.fn.make('gallery', {
	init: function() {
		if ($('ref:galleryTop').length) {
			this.$private.initGalleries();
		}
	},
	unload: function() {
		if ($('ref:galleryTop').length) {
			this.$private.unload();
		}
	}
}, {
	galleries: [],
	initGalleries: function() {
		var $galleries = $('ref:galleryTop');

		for (var i = 0; i < $galleries.length; i += 1) {
			this.initGallery($galleries[i], i);
		}
	},
	initGallery: function(el, index) {
		var $el = $(el),
			params = {
				nextButton: '.js-swiper-button-next-' + index,
				pagination: '.js-swiper-pagination-' + index,
				paginationClickable: true,
				prevButton: '.js-swiper-button-prev-' + index,
				loop: true
			},
			gallery,
			thumbs;

		if ($el.hasClass('js-use-fraction')) {
			   params.paginationType = 'fraction';
		}

		gallery = new Swiper($el, params);

		if ($el.data('thumbs')) {
			thumbs = new Swiper($('ref:galleryThumbs-' + index), {
				slideToClickedSlide: true,
				slidesPerView: 'auto',
				spaceBetween: 10,
				touchRatio: 0.2,
				control: gallery
			});

			gallery.params.control = thumbs;
		}

		this.galleries.push({
			gallery: gallery,
			thumbs: thumbs
		});
	},
	unload: function() {
		var galleries = this.galleries;

		if (galleries.length) {
			for (var i = 0; i < galleries.length; i += 1) {
				if (galleries[i].gallery && typeof galleries[i].gallery == 'function') {
					galleries[i].gallery.destroy();
				}

				if (galleries[i].thumbs && typeof galleries[i].thumbs == 'function') {
					galleries[i].thumbs.destroy();
				}
			}
		}
	}
});
